import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import {
    ModuleWithProviders,
    NgModule,
    Optional,
    SkipSelf
} from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { RouterModule } from '@angular/router';
import { SharedModule } from '@shared/shared.module';
import { GoogleAnalyticsLibModule } from 'src/app/modules/google-tag-manager/google-tag-manager.module';
import { ConfirmationDialogComponent } from './components/confirmation-dialog/confirmation-dialog.component';
import { FoundationFooterComponent } from './components/footer/footer.component';
import { FoundationHeaderComponent } from './components/header/header.component';
import { FoundationLayoutComponent } from './components/layout/layout.component';
import { NotFoundComponent } from './components/not-found/not-found.component';
import { ProcedureService } from './http/procedure.service';
import { DynamicScriptLoaderService } from './services/dynamic-script-loader.service';
import { UserService } from './user/user.service';

/**
 * `CoreModule` is the home of several singletons, including HTTP services. It should only ever be imported in the `AppModule`
 * and never in any feature modules, otherwise multiple instances of the singletons within would be created. Single use
 * components such as the header can also go in the `CoreModule`.
 */
@NgModule({ declarations: [
        FoundationLayoutComponent,
        FoundationHeaderComponent,
        FoundationFooterComponent,
        NotFoundComponent,
        ConfirmationDialogComponent
    ],
    exports: [NotFoundComponent, ConfirmationDialogComponent], imports: [BrowserModule,
        RouterModule,
        BrowserAnimationsModule,
        GoogleAnalyticsLibModule.forRoot(),
        SharedModule], providers: [DynamicScriptLoaderService, UserService, ProcedureService, provideHttpClient(withInterceptorsFromDi())] })
export class CoreModule {
    constructor (@Optional() @SkipSelf() parentModule: CoreModule) {
    // Import guard. Ensure this module is only ever created once.
        if (parentModule) {
            throw new Error(
                `${parentModule ? parentModule.constructor.name : 'Unknown module'} has already been loaded. Import Core module in the AppModule only.`
            );
        }
    }

    static forRoot (): ModuleWithProviders<SharedModule> {
        return {
            ngModule: SharedModule,
            providers: [
                // Other
                DynamicScriptLoaderService
            ]
        };
    }
}
